export const agentPreviewsQueryKey = () => ["previews", "agents"] as const;

export const agentUserPreviewsQueryKey = () => ["previews", "agent-users"] as const;
